export interface ApplyOn {
  key: string;
  value: string;
}

export const ApplyOnUtils = {
  create({ key, value }: { key: string; value: string }): ApplyOn {
    return {
      key,
      value,
    };
  },

  fromMap(map: { [key: string]: any }): ApplyOn {
    return {
      key: typeof map["key"] === "string" ? map["key"] : "",
      value: typeof map["value"] === "string" ? map["value"] : "",
    };
  },

  toMap(applyOn: ApplyOn): { [key: string]: any } {
    return {
      key: applyOn.key,
      value: applyOn.value,
    };
  },

  toJson(applyOn: ApplyOn): string {
    return JSON.stringify(ApplyOnUtils.toMap(applyOn));
  },

  empty(): ApplyOn {
    return { key: "", value: "" };
  },
};
